import { Flex, Form, Switch } from 'antd'
import clsx from 'clsx'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FormItem } from '../../components/form-item'
import { FormSection } from '../../components/form-section'
import { useCampaignLocale } from '../campaign-locale'
import { CampaignLanguageSelect } from './campaign-language-select'

type CampaignLanguageSettingsProps = {
    interview?: boolean
    disabled?: boolean
    className?: string
}

export function CampaignLanguageSettings({ interview = false, disabled, className }: CampaignLanguageSettingsProps) {
    const { t } = useTranslation()

    const form = Form.useFormInstance()
    const locale = useCampaignLocale(form)
    const allowLanguageSwitch = Form.useWatch('allowLanguageSwitch', { form, preserve: true })

    const language = t(`locales.${locale}`)

    return (
        <FormSection
            title={t('Language')}
            className={clsx('@container', className)}
        >
            <Flex
                gap="middle"
                className="flex-col @[600px]:flex-row"
            >
                <FormItem
                    name="locale"
                    className="mb-0 min-w-0 flex-1"
                    label={t('Conversation language')}
                    extra={t(
                        interview
                            ? 'Questions and evaluations are in {{language}}.'
                            : 'Evaa conducts the conversation in {{language}} by default. Evaluations are also in {{language}}.',
                        {
                            language,
                        }
                    )}
                    rules={[{ required: true }]}
                >
                    <CampaignLanguageSelect disabled={disabled} />
                </FormItem>
                <FormItem
                    name="allowLanguageSwitch"
                    label={t('Allow other languages')}
                    valuePropName="checked"
                    className="mb-0 min-w-0 flex-1"
                    extra={t(
                        allowLanguageSwitch
                            ? 'If a candidate writes in another language, Evaa continues in that language. Evaluations stay in {{language}}.'
                            : 'The conversation stays in {{language}}.',
                        { language }
                    )}
                >
                    <Switch
                        aria-label={t('Allow other languages')}
                        disabled={disabled}
                    />
                </FormItem>
            </Flex>
        </FormSection>
    )
}
